import { NotificationSeverity } from '../services/notifier';
import { Notification } from './notification';

export class NotificationWarn extends Notification {
  protected severity: NotificationSeverity = 'warn';
}
